import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Select from "react-select";

const TeammasterDetailsDesign = () => {
  const allowAlphabets = (v) => v.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (v) => v.replace(/[^0-9]/g, "");
  const navigate = useNavigate();
  const [designation, setdesignation] = useState("");
  const [Department, setDepartment] = useState("");
  const [Date, setDate] = useState("");
  const [EffectiveDate, setEffectiveDate] = useState("");
  const [Teamleader, setTeamleader] = useState("");
  const [TeamleaderList, setTeamleaderList] = useState([]);
  const [TeamleaderName, setTeamleaderName] = useState("");
  const [AddTeamLeader, setAddTeamLeader] = useState("");

  const [salesconsultant, setsalesconsultant] = useState("");
  const [salesconsultantList, setsalesconsultantList] = useState([]);
  const routerLocation = useLocation();
  const editUnqid = routerLocation.state?.unqid || null;
  const [editData, setEditData] = useState(null);
  const [gridRows, setGridRows] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      height: "40px",
      borderRadius: "5px",
      borderColor: "#ccc",
      boxShadow: "none",
      fontSize: "14px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "40px",
      padding: "0 10px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "40px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };
  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });
  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  useEffect(() => {
    fetchTeamLeader();
  }, []);

  const fetchTeamLeader = async () => {
    try {
      const response = await apiFetch(
        "/api/fetchteamleader",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await response.json();
      if (data.success) {
        setTeamleaderList(
          data.data.map((item) => ({ label: item.value, value: item.data })),
        );
      }
    } catch (error) {
      console.error("Error loading team leaders", error);
    }
  };

  const fetchGrid = async (teamLeaderId) => {
    try {
      const response = await apiFetch(
        "/api/fetchteamgrid",
        { method: "POST", body: JSON.stringify({ teamLeaderId }) },
      );
      const data = await response.json();
      if (data.success) {
        setGridRows(data.data || []);
      } else {
        setGridRows([]);
      }
    } catch (error) {
      console.error("Error loading grid", error);
      setGridRows([]);
    }
  };
  useEffect(() => {
    fetchSalesConsultantName();
  }, []);

  const fetchSalesConsultantName = async () => {
    try {
      const response = await apiFetch(
        "/api/fetchscname",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await response.json();
      if (data.success) {
        setsalesconsultantList(
          data.data.map((item) => ({ label: item.value, value: item.data })),
        );
      } else {
        setsalesconsultantList([]);
      }
    } catch (error) {
      console.error("Error loading sales consultant names", error);
      setsalesconsultantList([]);
    }
  };

  const fetchScDetails = async (scId) => {
    try {
      const response = await apiFetch(
        "/api/fetchscdetails",
        { method: "POST", body: JSON.stringify({ scId }) },
      );
      const data = await response.json();
      if (data.success && data.data) {
        setAddTeamLeader(data.data.teamleader || "");
        setdesignation(data.data.designation || "");
        setDepartment(data.data.department || "");
      } else {
        setAddTeamLeader("");
        setdesignation("");
        setDepartment("");
      }
    } catch (error) {
      console.error("Error fetching SC details", error);
    }
  };

  const handleSave = async () => {
    if (!Date || !EffectiveDate || !Teamleader || !salesconsultant) {
      alert("Please fill all required fields");
      return;
    }

    const payload = {
      entryDate: Date,
      effectiveDate: EffectiveDate,

      salesConsultantId: salesconsultant, // sp_517
      selectedTeamLeaderId: Teamleader, // sp_518
      addTeamLeaderName: AddTeamLeader, // sp_522

      department: Department, // ✅ FIXED
      designation,

      userId: storedUserInfo?.userid || "",
      ipAddress,
    };

    try {
      const response = await apiFetch(
        "/api/saveteam",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await response.json();
      if (data.success) {
        alert("Saved successfully");
        fetchGrid(Teamleader);
        setsalesconsultant("");
        setAddTeamLeader("");
        setdesignation("");
        setDepartment("");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Team Master</div>

          {/* ---------------- FORM ROW 1 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Date</label>
              <input
                type="date"
                value={Date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Team Leader</label>
              <Select
                options={TeamleaderList}
                value={
                  TeamleaderList.find((x) => x.value === Teamleader) || null
                }
                onChange={(selected) => {
                  const selectedId = selected?.value || ""; // ✅ ID
                  setTeamleader(selectedId);

                  setTeamleaderName(selected?.label || ""); // optional
                  setAddTeamLeader("");

                  if (selectedId) {
                    fetchGrid(selectedId);
                  } else {
                    setGridRows([]);
                  }
                }}
                styles={customStyles}
                placeholder="Select"
                isSearchable
                classNamePrefix="react-select"
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column">
              <label>Effective Date</label>
              <input
                type="date"
                value={EffectiveDate}
                onChange={(e) => setEffectiveDate(e.target.value)}
              />
            </div>
          </div>
          {/* Grid Section */}
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th style={{ width: "10%" }}>S.N.</th>
                  <th style={{ width: "45%" }}>Sales</th>
                  <th style={{ width: "45%" }}>Mobile No</th>
                </tr>
              </thead>

              <tbody>
                {gridRows.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>

                    <td>
                      <input
                        type="text"
                        className="grid-input"
                        value={row.name || ""} // ✅ FIX HERE
                        readOnly
                      />
                    </td>

                    <td>
                      <input
                        type="text"
                        className="grid-input"
                        value={row.mobile || ""}
                        readOnly
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <br></br>
          <div className="header1">Add Sale Consultant</div>
          {/* ---------------- TABLE ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Sale Consultant:</label>
              <Select
                options={salesconsultantList}
                value={
                  salesconsultantList.find(
                    (x) => x.value === salesconsultant,
                  ) || null
                }
                onChange={(selected) => {
                  const scId = selected?.value || ""; // ✅ ID (sp_517)
                  setsalesconsultant(scId);

                  if (scId) {
                    fetchScDetails(scId);
                  } else {
                    setAddTeamLeader("");
                    setdesignation("");
                    setDepartment("");
                  }
                }}
                styles={customStyles}
                placeholder="Select"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column">
              <label>Team Leader</label>
              <input
                type="text"
                value={AddTeamLeader}
                onChange={(e) =>
                  setAddTeamLeader(allowAlphabets(e.target.value))
                }
                placeholder="Enter Team Leader"
              />
            </div>
            <div className="form-column">
              <label>Designation</label>
              <input
                type="text"
                value={designation}
                onChange={(e) => setdesignation(allowAlphabets(e.target.value))}
              />
            </div>
            <div className="form-column">
              <label>Department</label>
              <input
                type="text"
                value={Department}
                onChange={(e) => setDepartment(allowAlphabets(e.target.value))}
              />
            </div>
          </div>

          {/* ---------------- BUTTONS ---------------- */}
          <div style={buttonContainerStyle}>
            {!isEditing && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {isEditing && (
              <button className="btn-save" style={buttonStyle("#2e20abff")}>
                Update
              </button>
            )}

            <button style={buttonStyle("#ab2025")}>Exit</button>
          </div>
        </div>
      </div>

      {/* ----------------------------------------------------
            CSS EXACTLY LIKE INSURANCE MASTER / RATE MASTER
      ---------------------------------------------------- */}
      <style>
        {`
/* ===== PAGE LAYOUT ===== */
/* ================= PAGE ================= */

.page-container{
  width:100%;
  min-height:100vh;
  background:#f4f6f8;
  display:flex;
  justify-content:center;
  padding:10px;
}

.container{
  width:100%;
  max-width:100%;
  background:#fff;
  border-radius:8px;
  padding:15px;
  box-shadow:0 4px 8px rgba(0,0,0,.1);
}

.header,.header1{
  text-align:center;
  font-size:1.5rem;
  font-weight:bold;
  padding:15px;
  background:#8B1E3F;
  color:#fff;
  border-radius:6px;
  margin-bottom:20px;
}

.header1{height:60px}

/* ================= FORM GRID ================= */

/* Desktop default = 4 */

.form-row{
  display:grid;
  grid-template-columns:repeat(4,1fr);
  gap:15px;
  margin-bottom:15px;
}

.form-column{
  display:flex;
  flex-direction:column;
}

label{
  font-size:14px;
  font-weight:600;
  margin-bottom:4px;
}

input,select{
  height:40px!important;
  width:100%!important;
  padding:8px 10px;
  border:1px solid #ccc;
  border-radius:5px;
  background:#fff;
  font-size:14px;
  box-sizing:border-box;
}

/* ================= RESPONSIVE ================= */

/* Laptop = 3 */
@media(max-width:1400px){
  .form-row{
    grid-template-columns:repeat(3,1fr);
  }
}

/* iPad = 2 */
@media(max-width:1024px){
  .form-row{
    grid-template-columns:repeat(2,1fr);
  }
}

/* Mobile = 1 */
@media(max-width:600px){
  .form-row{
    grid-template-columns:1fr;
  }

  .page-container,
  .container{
    width:100%;
    max-width:100%;
    padding:10px;
  }

  .App{
    text-align:left!important;
  }
}

/* ================= TABLE ================= */

.table-container{
  overflow-x:auto;
  margin-top:25px;
  border:1px solid #ddd;
  border-radius:6px;
}

table{
  width:max-content;
  min-width:100%;
  border-collapse:collapse;
  font-size:13px;
  table-layout:fixed;
}

th{
  background:#f8bcbc;
  padding:10px;
  border:1px solid #ccc;
  white-space:nowrap;
  text-align:center;
  position:sticky;
  top:0;
  z-index:2;
}

td{
  border:1px solid #ccc;
  padding:6px;
  text-align:center;
  min-width:110px;
}

/* grid inputs */
.grid-input{
  width:100%;
  height:32px;
  border:1px solid #ccc;
  border-radius:4px;
  text-align:center;
  font-size:13px;
}

/* ================= BUTTONS ================= */

.button-container{
  width:100%;
  display:flex;
  justify-content:center;
  align-items:center;
  gap:15px;
  margin-top:25px;
  flex-wrap:wrap;
}

.btn-save{
  background:#4caf50;
  color:#fff;
  border:none;
  padding:10px 25px;
  border-radius:5px;
  font-weight:600;
  cursor:pointer;
  min-width:140px;
}

.btn-exit{
  background:#a20d0d;
  color:#fff;
  border:none;
  padding:10px 25px;
  border-radius:5px;
  font-weight:600;
  cursor:pointer;
  min-width:140px;
}

/* Keep buttons centered in ONE ROW even on mobile */
@media(max-width:600px){
  .button-container{
    flex-direction:row;
  }
}
/* Fix react-select dropdown hiding inside grid */
.react-select__menu-portal {
  z-index: 99999 !important;
}

/* Allow dropdown to overflow containers */
.table-container {
  overflow-x: auto;
  overflow-y: visible !important;
}

`}
      </style>
    </Layout>
  );
};

export default TeammasterDetailsDesign;
